import React, { RefObject, Fragment } from 'react';
import { Link } from 'react-router-dom';
import { SignaturePad } from '@creatdevsolutions/cs-react-signature-pad';
import { Button, TextField } from '@material-ui/core';
import { withStyles } from '@material-ui/core/styles';
import styles from './driverSignature.module.css';
import commonStyles from '../../common/common.module.css';
import Checkbox from '@material-ui/core/Checkbox';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import CheckBoxOutlineBlankIcon from '@material-ui/icons/CheckBoxOutlineBlank';
import CheckBoxIcon from '@material-ui/icons/CheckBox';

const stylesMaterial = (theme: any) => ({
  saveButton: {
    marginLeft: '20px'
  },
  textField: {
    width: '100%'
  },
  '@media(max-width: 411px)': {
    link: {
      marginTop: '10px'
    }
  }
});

interface DriverSignatureProps {
  classes: any,
  signaturePadRef: RefObject<SignaturePad>,
  saveSignature: () => void,
  clearSignature: () => void,
  isDisabledSave: Function,
  onStrokeEnd: Function,
  savedSignatureUrl: string,
  driverName: string,
  signaturePadWidth: number,
  signaturePadHeight: number,
  PONumber: string | null,
  awb: string | null,
  showHeader: boolean,
  confirmationType: 'return' | 'delivery',
  type: 'po' | 'do' | 'rfs' | 'go',
  onSignatureError: () => void;
  signatureError: boolean;
  goodsValue: boolean;
  updateGoodsValue: Function;
  remarksText: string;
  handleRemarksChange: Function;
};

const driverSignature = (props: DriverSignatureProps) => {
  return (
    <div className={styles.signatureWrapper}>
      {props.showHeader && (<div className={styles.signatureHeaderWrapper}>
        <div className={styles.headerFlexContainer}>
          <div className={styles.headerItem}><span className={styles.poNumber}>{props.awb || props.PONumber}</span>
            {props.confirmationType === 'return' ? "Return to Driver" : "Freight on Hand"}
          </div>
        </div>
      </div>)}

      {props.confirmationType === 'return' && <div className={`${commonStyles.wrapper} ${styles.wrapper}`} >
        <h3 className={commonStyles.header}>Remarks</h3>
        <TextField
          id="outlined-multiline-flexible"
          placeholder="-- Enter remarks"
          multiline
          rows="3"
          rowsMax="3"
          value={props.remarksText || ''}
          onChange={(event) => props.handleRemarksChange(event)}
          variant="outlined"
          className={props.classes.textField}
          disabled={!!props.savedSignatureUrl || false}
        />
      </div>}

      <div className={`${commonStyles.wrapper} ${styles.wrapper}`}>
        <h3 className={`${commonStyles.header}`}> Signature</h3>
        <div className={styles.signatureImageContainer}>
          {props.signatureError && <div className={styles.fullyReturnedNoSignatureText}>The {props.type === 'po' ? "pickup" : "drop off"} order is fully returned</div>}
          {!props.signatureError && props.savedSignatureUrl &&
            <div>
              <img src={props.savedSignatureUrl} onError={props.onSignatureError} className={styles.signatureImage} />
            </div>
          }
          <div>
            {!props.savedSignatureUrl && <SignaturePad className={styles.signatureImage} ref={props.signaturePadRef}
              width={props.signaturePadWidth}
              height={props.signaturePadHeight}
              penColor={'black'}

              onEnd={props.onStrokeEnd} />
            }
          </div>
        </div>
      </div>

      <div className={styles.driverWrapperMain}>Driver: {props.driverName || '--'}</div>
      <div className={styles.driverWrapper}>The undersigned acknowledges the receipt of goods complete and in good condition unless exception noted</div>
      <div className={styles.driverWrapper}><FormControlLabel
        key={'all'}
        label={"Dangerous Goods Declaration received"}
        control={
          <Checkbox
            checked={props.goodsValue}
            onChange={() => props.updateGoodsValue()}
            color="primary"
            className={props.classes.checkbox}
            icon={<CheckBoxOutlineBlankIcon className={props.classes.sizeIcon} />}
            checkedIcon={<CheckBoxIcon className={props.classes.sizeIcon} />}
          />
        }
        className={props.classes.formControlLabel}
      /></div>
      <div className={`${styles.buttonsWrapper} ${props.savedSignatureUrl ? '' : styles.buttonsWrapperEnd}`}>
        <div className={styles.exitButtonContainer}>
          <Link to={`/whs/${props.type}/${props.PONumber}`} className={props.classes.link}>
            <Button variant='contained' color='primary'>Exit</Button>
          </Link>
        </div>
        <div className={styles.buttonsContainer}>
          <Button variant='contained' color='default' disabled={props.isDisabledSave('clear')} onClick={props.clearSignature}>Clear</Button>
          <Button variant='contained' color='default' disabled={props.isDisabledSave('save')} onClick={props.saveSignature} className={props.classes.saveButton}>Save</Button>
        </div>
      </div>
    </div>
  );
};
export default withStyles(stylesMaterial)(driverSignature);